import { render, staticRenderFns } from "./close-icon.vue?vue&type=template&id=f0207630&scoped=true&"
var script = {}
import style0 from "./close-icon.vue?vue&type=style&index=0&id=f0207630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0207630",
  null
  
)

export default component.exports